export default [
  {
    path: '/doc',
    name: 'doc',
    redirect: '/doc/ecg',
    meta: {
      title: '',
    },
    children: [
      {
        path: 'ecg',
        name: 'ecg',
        component: () => import('@/views/doc/ECGInstruction.vue'),
        meta: {
          title: '心电检测使用说明',
        },
      },
    ],
  },
]
